function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { getCurrentUser } from "../../utils/utils";
import * as GA from "./ThirdPartyServices/GoogleAnalytics";
function usersOnly(f) {
    return _usersOnly.apply(this, arguments);
}
function _usersOnly() {
    _usersOnly = // usersOnly is a wrapper, used internally in this module, that filters out
    // function calls if the user is a staff member, so they don't affect our results.
    _asyncToGenerator(regeneratorRuntime.mark(function _callee(f) {
        var currentUser;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getCurrentUser();
                case 2:
                    currentUser = _ctx.sent;
                    if (!currentUser.isAdmin) {
                        f();
                    }
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _usersOnly.apply(this, arguments);
}
export var registerPageview = function(track) {
    GA.registerPageview(track);
};
// Dataset-related events
export var viewDataset = function(_datasetId, suffix) {
    return usersOnly(function() {
        GA.sendDatasetEvent("dataset-shown", suffix);
    });
};
export var exploreMoreDatasetsClicked = function(_datasetId) {
    return usersOnly(function() {
        GA.sendDatasetEvent("explore-more-datasets-clicked");
    });
};
export var datasetPreviewTabShown = function(tab, _datasetId) {
    return usersOnly(function() {
        GA.sendDatasetEvent("data-preview-tab-shown", tab);
    });
};
// Dataset downloads are tracked in a granular way in GA, to differentiate
// where people click.
export var downloadDataset = function(datasetId) {
    return usersOnly(function() {
        return downloadDatasetCommon(datasetId);
    });
};
export var downloadDatasetFileOnDataTab = function(datasetId) {
    return usersOnly(function() {
        GA.sendDatasetEvent("data-tab-download-file");
        downloadDatasetCommon(datasetId);
    });
};
export var downloadDatasetOnDataTab = function(datasetId) {
    return usersOnly(function() {
        GA.sendDatasetEvent("data-tab-download-all-list");
        downloadDatasetCommon(datasetId);
    });
};
export var clickedSuggestion = function(entityId, entityType) {
    return usersOnly(function() {
        return GA.clickedSuggestion(entityId, entityType);
    });
};
function downloadDatasetCommon(_datasetId) {
// no-op, was used to track Google Conversions before that was removed.
}
// The different ways of upvoting datasets are differentiated in GA.
export var upvotedDatasetOnHeader = function(_datasetId, suffix) {
    return usersOnly(function() {
        GA.sendUpvote("dataset", suffix);
    });
};
export var upvotedDatasetOnDatasetList = function(_datasetId, suffix) {
    return usersOnly(function() {
        GA.sendUpvote("dataset", suffix);
    });
};
export var newDatasetVersionCreated = function(convertCsv) {
    return usersOnly(function() {
        GA.sendDatasetNewVersionEvent(convertCsv ? "convert-csv" : undefined);
    });
};
// Kernel events
export var newScript = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("new-script");
    });
};
export var newNotebook = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("new-notebook");
    });
};
export var editKernel = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("edit-kernel");
    });
};
export var newKernelClicked = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("new-kernel-clicked");
    });
};
export var viewScript = function(_scriptId, suffix) {
    return usersOnly(function() {
        GA.sendKernelEvent("script-shown", suffix);
    });
};
export var upvoteScript = function(_scriptId, suffix) {
    return usersOnly(function() {
        GA.sendUpvote("script", suffix);
    });
};
export var exploreMoreKernelsClicked = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("explore-more-kernels-clicked");
    });
};
export var newKernelUsingThisDataClicked = function() {
    return usersOnly(function() {
        GA.sendKernelEvent("new-kernel-using-this-data-clicked");
    });
};
// Discussion-related events
export var upvoteForumPost = function() {
    return usersOnly(function() {
        GA.sendUpvote("forum-message");
    });
};
export var downvoteForumPost = function() {
    return usersOnly(function() {
        GA.sendDownvote("forum-message");
    });
};
export var upvoteForumTopic = function() {
    return usersOnly(function() {
        GA.sendUpvote("forum-topic");
    });
};
export var downvoteForumTopic = function() {
    return usersOnly(function() {
        GA.sendDownvote("forum-topic");
    });
};
export var upvoteForumTopicList = function() {
    return usersOnly(function() {
        GA.sendUpvote("topic-list");
    });
};
export var downvoteForumTopicList = function() {
    return usersOnly(function() {
        GA.sendDownvote("topic-list");
    });
};
// User-related events
export var clickedAvatarInNewsfeed = function() {
    return usersOnly(function() {
        GA.sendAvatarEvent("newsfeed");
    });
};
// New user signups are tracked with GA.
export var userSignup = function() {
    GA.sendAccountEvent("new-account");
};
// Newsfeed-related events
export var upvotedNewsfeedStoryHeader = function() {
    return usersOnly(function() {
        GA.sendUpvote("newsfeed");
    });
};
// An "export default" list helps consumers of this module avoid wildcard
// imports, per our style guide.
export default {
    viewDataset: viewDataset,
    exploreMoreDatasetsClicked: exploreMoreDatasetsClicked,
    downloadDataset: downloadDataset,
    downloadDatasetFileOnDataTab: downloadDatasetFileOnDataTab,
    downloadDatasetOnDataTab: downloadDatasetOnDataTab,
    downloadDatasetCommon: downloadDatasetCommon,
    upvotedDatasetOnHeader: upvotedDatasetOnHeader,
    upvotedDatasetOnDatasetList: upvotedDatasetOnDatasetList,
    newDatasetVersionCreated: newDatasetVersionCreated,
    newKernelClicked: newKernelClicked,
    viewScript: viewScript,
    upvoteScript: upvoteScript,
    exploreMoreKernelsClicked: exploreMoreKernelsClicked,
    upvoteForumPost: upvoteForumPost,
    downvoteForumPost: downvoteForumPost,
    upvoteForumTopic: upvoteForumTopic,
    downvoteForumTopic: downvoteForumTopic,
    upvoteForumTopicList: upvoteForumTopicList,
    downvoteForumTopicList: downvoteForumTopicList,
    clickedAvatarInNewsfeed: clickedAvatarInNewsfeed,
    userSignup: userSignup,
    upvotedNewsfeedStoryHeader: upvotedNewsfeedStoryHeader,
    datasetPreviewTabShown: datasetPreviewTabShown,
    clickedSuggestion: clickedSuggestion,
    newKernelUsingThisDataClicked: newKernelUsingThisDataClicked,
    registerPageview: registerPageview
};
